import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";
import { Link } from "wouter";

const customerCapabilities = [
  "Identity resolution across channels and devices",
  "Behavioral and transactional data integration",
  "Real-time profile updates and segmentation",
  "Privacy-first architecture with consent management",
  "Activation across marketing, sales, and service platforms"
];

const CDP = () => {
  return (
    <section id="cdp" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-10 md:mb-0 md:pr-10">
            <h2 className="text-3xl font-bold mb-6">Customer Data Platform</h2>
            <p className="text-lg text-gray-600 mb-6">
              Build comprehensive 360° customer views that unify data from all touchpoints 
              to power personalized experiences and data-driven marketing.
            </p>
            
            <div className="bg-white p-6 rounded-lg shadow-md mb-6">
              <h3 className="font-semibold text-xl mb-4">Customer 360 Capabilities</h3>
              <div className="space-y-3">
                {customerCapabilities.map((capability, index) => (
                  <div key={index} className="flex items-center">
                    <CheckCircle className="h-5 w-5 text-green-500 mr-3" />
                    <span>{capability}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <Link href="/contact">
              <Button className="bg-blue-600 hover:bg-blue-700">
                Discuss Your CDP Needs
              </Button>
            </Link>
          </div>
          
          <div className="md:w-1/2">
            <div className="bg-white rounded-lg shadow-lg p-6">
              <h3 className="font-semibold text-xl mb-4 text-center">Customer 360 View</h3>
              <div className="relative">
                <div className="w-64 h-64 mx-auto rounded-full bg-blue-600/10 flex items-center justify-center relative">
                  <div className="absolute inset-0 rounded-full border-2 border-dashed border-blue-600/30 animate-spin" style={{ animationDuration: '30s' }}></div>
                  <div className="w-48 h-48 rounded-full bg-white shadow-lg flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-blue-600/70">
                      <path d="M18 20a6 6 0 0 0-12 0" />
                      <circle cx="12" cy="10" r="4" />
                      <circle cx="12" cy="12" r="10" />
                    </svg>
                  </div>
                  
                  {/* Data Points */}
                  <div className="absolute top-0 -translate-y-1/2 bg-white px-4 py-2 rounded-full shadow-md">
                    <span className="font-semibold">Demographics</span>
                  </div>
                  <div className="absolute right-0 translate-x-1/2 bg-white px-4 py-2 rounded-full shadow-md">
                    <span className="font-semibold">Purchase History</span>
                  </div>
                  <div className="absolute bottom-0 translate-y-1/2 bg-white px-4 py-2 rounded-full shadow-md">
                    <span className="font-semibold">Online Behavior</span>
                  </div>
                  <div className="absolute left-0 -translate-x-1/2 bg-white px-4 py-2 rounded-full shadow-md">
                    <span className="font-semibold">Support Interactions</span>
                  </div>
                </div>
                
                <div className="mt-8 text-center">
                  <h4 className="font-semibold text-lg mb-2">Unified Customer Data</h4>
                  <p className="text-gray-600">
                    All customer information in one place, accessible across your organization
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CDP;
